import { createContext, useContext } from "react";

const tableIdContext = createContext(undefined);

export const TableIdProvider = tableIdContext.Provider;

export default function useTableId() {
  const context = useContext(tableIdContext);

  if (!context) throw new Error("useTableId must be used within a TableIdProvider");

  return context;
}
